import { isTerminalBuildState, BuildStates } from "app/constants/BuildStates";

interface Props {
  missingDependencies: string[];
  build: {
    state: BuildStates;
  };
}

export const MissingStepDependencies = (props: Props) => {
  if (!props.missingDependencies?.length) {
    return null;
  }

  return (
    <div>
      <p className="mt-0 mb-3">
        {isTerminalBuildState(props.build.state) ? (
          <span className="bg-red-100">The following dependencies were not found:</span>
        ) : (
          <span className="bg-orange-100">
            The following dependencies are either invalid or have yet to be resolved:
          </span>
        )}
      </p>

      <ul className="divide-y depth rounded max-w-lg mb-3">
        {props.missingDependencies.map((dep) => (
          <li key={dep} className="monospace border-gray-300 text-xs p-2.5 m-0">
            {dep}
          </li>
        ))}
      </ul>
      <p className="m-0">
        Check the pipeline is configured correctly, or see the{" "}
        <a href="/docs/pipelines/dependencies" className="text-inherit underline">
          documentation
        </a>
        .
      </p>
    </div>
  );
};
